const PRINT_MODE_STORAGE_KEY = 'printMode';
const PRINT_MODE_LOCAL = 'local';
const PRINT_MODE_REMOTE = 'remote';

const PRINT_MODE_OPTIONS = [PRINT_MODE_LOCAL, PRINT_MODE_REMOTE];
const DEFAULT_PRINT_MODE = PRINT_MODE_LOCAL;

const PRINT_MODE_LABELS = {
  [PRINT_MODE_LOCAL]: 'Imprimir desde el navegador (PDF)',
  [PRINT_MODE_REMOTE]: 'Enviar a impresora remota',
};

const PRINT_MODE_DESCRIPTIONS = {
  [PRINT_MODE_LOCAL]: 'Se abre el PDF localmente para imprimir desde este navegador.',
  [PRINT_MODE_REMOTE]: 'Envia la solicitud a la impresora configurada en el servidor.',
};

const normalizePrintMode = (mode) =>
  PRINT_MODE_OPTIONS.includes(mode) ? mode : DEFAULT_PRINT_MODE;

const getPrintMode = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return DEFAULT_PRINT_MODE;
  }
  try {
    const stored = window.localStorage.getItem(PRINT_MODE_STORAGE_KEY);
    return normalizePrintMode(stored);
  } catch (error) {
    return DEFAULT_PRINT_MODE;
  }
};

const savePrintMode = (mode) => {
  const normalized = normalizePrintMode(mode);
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem(PRINT_MODE_STORAGE_KEY, normalized);
  }
  return normalized;
};

export {
  DEFAULT_PRINT_MODE,
  PRINT_MODE_DESCRIPTIONS,
  PRINT_MODE_LABELS,
  PRINT_MODE_LOCAL,
  PRINT_MODE_OPTIONS,
  PRINT_MODE_REMOTE,
  getPrintMode,
  savePrintMode,
};
